export const STORE_DESIGNS = {
  9: {
    id: 9,
    name: 'Bazar Lumina',
    slug: 'bazar-lumina',
    market: 'bazar',
    home: 'man',
    nav: 'commerce',
    productCard: 'editorial',
  },
  10: {
    id: 10,
    name: 'Tecno Pulse',
    slug: 'tecno-pulse',
    market: 'electronics',
    home: 'man',
    nav: 'commerce',
    productCard: 'compact',
  },
  11: {
    id: 11,
    name: 'Hombre Atelier',
    slug: 'hombre-atelier',
    market: 'menswear',
    home: 'man',
    nav: 'commerce',
    productCard: 'editorial',
  },
  12: {
    id: 12,
    name: 'Mujer Maison',
    slug: 'mujer-maison',
    market: 'womenswear',
    home: 'd5',
    nav: 'boutique',
    productCard: 'editorial',
  },
  13: {
    id: 13,
    name: 'Deco Serena',
    slug: 'deco-serena',
    market: 'home-deco',
    home: 'd5',
    nav: 'boutique',
    productCard: 'soft',
  },
  14: {
    id: 14,
    name: 'Kids Pop',
    slug: 'kids-pop',
    market: 'kids',
    home: 'd5',
    nav: 'playful',
    productCard: 'soft',
  },
  15: {
    id: 15,
    name: 'Beauty Glow',
    slug: 'beauty-glow',
    market: 'beauty',
    home: 'd5',
    nav: 'boutique',
    productCard: 'soft',
  },
  16: {
    id: 16,
    name: 'Sport Grid',
    slug: 'sport-grid',
    market: 'sports',
    home: 'man',
    nav: 'commerce',
    productCard: 'compact',
  },
  17: {
    id: 17,
    name: 'Pet Friendly',
    slug: 'pet-friendly',
    market: 'pet',
    home: 'd5',
    nav: 'playful',
    productCard: 'soft',
  },
  18: {
    id: 18,
    name: 'Gourmet Fresh',
    slug: 'gourmet-fresh',
    market: 'gourmet',
    home: 'man',
    nav: 'commerce',
    productCard: 'compact',
  },
  19: {
    id: 19,
    name: 'Urban Drop',
    slug: 'urban-drop',
    market: 'streetwear',
    home: 'man',
    nav: 'split',
    productCard: 'editorial',
  },
  20: {
    id: 20,
    name: 'Prisma Joyas',
    slug: 'prisma-joyas',
    market: 'jewelry',
    home: 'd5',
    nav: 'boutique',
    productCard: 'soft',
  },
  21: {
    id: 21,
    name: 'Papel Vivo',
    slug: 'papel-vivo',
    market: 'bookstore',
    home: 'man',
    nav: 'editorial',
    productCard: 'compact',
  },
  22: {
    id: 22,
    name: 'Nordika Home',
    slug: 'nordika-home',
    market: 'furniture',
    home: 'd5',
    nav: 'magazine',
    productCard: 'editorial',
  },
  23: {
    id: 23,
    name: 'Auto Pro',
    slug: 'auto-pro',
    market: 'autoparts',
    home: 'man',
    nav: 'utility',
    productCard: 'compact',
  },
  24: {
    id: 24,
    name: 'Farma Clara',
    slug: 'farma-clara',
    market: 'pharmacy',
    home: 'd5',
    nav: 'tabs',
    productCard: 'compact',
  },
  25: {
    id: 25,
    name: 'Toolbox Pro',
    slug: 'toolbox-pro',
    market: 'hardware',
    home: 'man',
    nav: 'market',
    productCard: 'compact',
  },
  26: {
    id: 26,
    name: 'Raíz Artesanal',
    slug: 'raiz-artesanal',
    market: 'handmade',
    home: 'd5',
    nav: 'editorial',
    productCard: 'soft',
  },
  27: {
    id: 27,
    name: 'Neon Gamer',
    slug: 'neon-gamer',
    market: 'gaming',
    home: 'man',
    nav: 'command',
    productCard: 'compact',
  },
  28: {
    id: 28,
    name: 'Terra Outdoor',
    slug: 'terra-outdoor',
    market: 'outdoor',
    home: 'man',
    nav: 'expedition',
    productCard: 'editorial',
  },
};

export const getStoreDesign = (design) => STORE_DESIGNS[Number(design)] || null;

export const isStoreDesign = (design) => Boolean(getStoreDesign(design));
